import React from 'react';

import { Button, Dialog, Icon, Sheet, Space, Typography } from '@sravni/react-design-system';
import { Cross } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import styles from './user-actions.module.scss';

interface IProps {
  showDialog: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  confirmText?: string;
  cancelText?: string;
}

export const ActionDialog: React.FC<IProps> = ({ showDialog, onClose, onConfirm, title, confirmText, cancelText }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Sheet visible={showDialog} onClose={onClose}>
        <Sheet.Header title={title} />
        <Sheet.Footer>
          <Space direction={'vertical'} className={'h-mt-12'} justify={'center'} align={'center'}>
            <Button onClick={onConfirm} className={styles.dialogButton} color={'red'} variant={'primary'} size={52}>
              {confirmText || 'Удалить'}
            </Button>
            <Button className={styles.dialogButton} onClick={onClose} size={52}>
              {cancelText || 'Отменить'}
            </Button>
          </Space>
        </Sheet.Footer>
      </Sheet>
    );
  }

  return (
    <Dialog visible={showDialog} closable={false} onClose={onClose}>
      <Dialog.Content className={styles.deleteDialogWrapperDesk}>
        <Space align={'center'} justify={'space-between'}>
          <Typography.Text size={16} strong className={'h-mr-12'}>
            {title}
          </Typography.Text>
          <Icon size={20} icon={<Cross />} strong={true} onClick={onClose} />
        </Space>
        <Space className={'h-mt-12'} justify={'space-between'}>
          <Button className={styles.dialogButton} onClick={onClose} size={36}>
            {cancelText || 'Отменить'}
          </Button>
          <Button onClick={onConfirm} className={styles.dialogButton} color={'red'} variant={'primary'} size={36}>
            {confirmText || 'Удалить'}
          </Button>
        </Space>
      </Dialog.Content>
    </Dialog>
  );
};
